import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import Header from "Components/Header";
import Footer from "Components/Footer";
import { Link } from "react-router-dom";
import logo_wh from "Images/fixo_ko2_wh.png";
import mainPaperText from "Images/main_paper_text.png";
import mainPaperImg1 from "Images/main_paper_1.png";
import mainPaperImg2 from "Images/main_paper_2.png";
import MainPaperLink1 from "Images/MainPaperLink_1.png";
import MainPaperLink2 from "Images/MainPaperLink_2.png";
import { device } from "Styles/Media";

const Main = () => {
  const paper = useRef();

  useEffect(() => {
    let mouseWheel = () => {
      const currentScroll = window.pageYOffset - 580;
      let checkpoint = 350;
      if (currentScroll <= checkpoint) {
        paper.current.style.opacity = 1 - currentScroll / checkpoint;
      } else {
        paper.current.style.opacity = 0;
      }
    };
    window.addEventListener("scroll", mouseWheel);
    return () => window.removeEventListener("scroll", mouseWheel);
  }, []);

  return (
    <Container>
      <Header />
      <MainSection>
        <MainDesc>
          <MainDescWrap>
            <MainDescLogo src={logo_wh} alt="픽소서" />
            <MainDescFirst>
              그 회사, 그 직무 선배가 <br />
              직접 자소서를 봐드립니다.
            </MainDescFirst>
            <MainDescSecond>
              지원하는 회사 선배가 살펴보고,
              <br /> 회사가 뽑고 싶은 자소서로 만들어 드립니다.
            </MainDescSecond>
            <Link to="/editform">
              <MainDescBtn>신청하기</MainDescBtn>
            </Link>
          </MainDescWrap>
        </MainDesc>
        <MainPaperSeciton>
          <img className="papertext" src={mainPaperText} alt="" />
          <MainPaper>
            <div />
            <div className="front" ref={paper} />
          </MainPaper>
          <MainPaperLinkUser>
            <p>
              <br />
              취업 ,이직을 준비중이라면,
              <br />
              <strong>자소서 첨삭 의뢰하기</strong>
            </p>
            <Link to="/editform">
              <img src={MainPaperLink1} alt="자소서 첨삭 의뢰하기" />
            </Link>
          </MainPaperLinkUser>
          <MainPaperLinkCorrector>
            <p>
              <br />
              현직자, 재직자라면
              <br />
              <strong>첨삭자 등록하기</strong>
            </p>
            <Link to="/corrector-register">
              <img src={MainPaperLink2} alt="첨삭자 등록하기" />
            </Link>
          </MainPaperLinkCorrector>
        </MainPaperSeciton>
      </MainSection>
      <Footer />
    </Container>
  );
};

export default Main;

const Container = styled.div`
  position: relative;
  min-height: 100vh;
  padding-bottom: 250px;
`;

const MainSection = styled.section``;

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MainDesc = styled(Center)`
  width: 100%;
  height: 500px;
  background: rgb(121, 3, 212);
  background: linear-gradient(
    105deg,
    rgba(121, 3, 212, 1) 75%,
    rgba(161, 41, 255, 1) 98%
  );
`;

const MainDescWrap = styled(Center)`
  flex-direction: column;
  width: 100%;
`;

const MainDescLogo = styled.img`
  width: 80px;
  margin-bottom: 20px;
`;

const MainDescFirst = styled.p`
  font-size: 2.5rem;
  font-weight: bold;
  line-height: 1.24;
  text-align: center;
  color: #ffffff;
  @media ${device.mobile} {
    font-size: 1.9rem;
  }
`;

const MainDescSecond = styled.p`
  margin-top: 20px;
  font-size: 1.3rem;
  font-weight: lighter;
  line-height: 1.41;
  text-align: center;
  color: #ffffff;
`;

const MainDescBtn = styled(Center)`
  padding: 13px 23px;
  margin-top: 23px;
  border-radius: 12px;
  background-color: #ffffff;
  font-size: 19px;
  font-weight: bold;
  color: #7903d4;
`;

const MainPaperSeciton = styled.section`
  margin-bottom: 100px;
  display: flex;
  flex-direction: column;
  .papertext {
    display: block;
    max-width: 560px;
    margin: 130px auto 60px;
    @media ${device.tablet} {
      width: 85%;
    }
    @media ${device.mobile} {
      width: 90%;
    }
  }
`;

const MainPaper = styled.div`
  display: grid;
  max-height: 800px;
  height: 67vw;
  @media ${device.tablet} {
    height: 75vw;
  }
  @media ${device.mobile} {
    height: 90vw;
  }
  div {
    grid-column: 1;
    grid-row: 1;
    background-size: 50vw;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #fff;
    transition: opacity 0.1s;
    &:first-child {
      color: red;
      background: url(${mainPaperImg2}) no-repeat 53%;
      background-size: contain;
      @media ${device.tablet} {
        background-position-x: 54%;
      }
    }
    &:nth-child(2) {
      color: red;
      background: url(${mainPaperImg1}) no-repeat 53%;
      background-size: contain;
      @media ${device.tablet} {
        background-position-x: 54%;
      }
    }
  }
`;

const MainPaperLinkUser = styled.div`
  width: 50vw;
  text-align: right;
  @media ${device.mobile} {
  }
  p {
    text-align: right;
    font-size: 28px;
    line-height: 38px;
    color: #444;
    @media ${device.tablet} {
      font-size: 23px;
      line-height: 35px;
    }
    @media ${device.mobile} {
      font-size: 18px;
      line-height: 31px;
    }
    strong {
      padding: 4px 10px;
      background-color: #acf2bd;
      @media ${device.tablet} {
        padding: 3px 6px;
      }
    }
  }
  p::before {
    content: "";
    display: inline-block;
    height: 100px;
    width: 2px;
    margin: 60px 0 20px;
    text-align: right;
    background-color: #444;
    @media ${device.mobile} {
      height: 100px;
      width: 1px;
      margin: 30px 0 20px;
    }
  }
  a {
    img {
      width: 180px;
      margin: 20px 0;
      cursor: pointer;
      @media ${device.tablet} {
        width: 160px;
        margin: 13px 0;
      }
      @media ${device.mobile} {
        width: 150px;
        margin: 10px 0;
      }
    }
  }
  a img:hover {
    animation: moveLeft 0.5s ease-in;
    animation-iteration-count: 1;
    animation-fill-mode: both;
  }
  @keyframes moveLeft {
    0% {
      margin-right: 0;
    }
    100% {
      margin-right: -30px;
    }
  }
`;

const MainPaperLinkCorrector = styled(MainPaperLinkUser)`
  width: 50vw;
  text-align: left;
  margin-left: auto;
  p {
    text-align: left;
    p::before {
      margin: 20px 0;
    }
    strong {
      background-color: #f8b1a9;
    }
  }
  a img:hover {
    animation: moveRight 0.5s ease-in;
    animation-iteration-count: 1;
    animation-fill-mode: both;
  }
  @keyframes moveRight {
    0% {
      margin-left: 0;
    }
    100% {
      margin-left: -30px;
    }
  }
`;
